<div class="wrapper">
  <ng-template [ngIf]="!showIcon" [ngIfElse]="icon">
    <img class="media-image" [src]="imageSrc" (error)="onError()" />
    <div class="overlay">
      <span class="overlay-title">
        <p>{{ item?.description ? item?.description : title }}</p>
        <p>{{ item.user?.firstName }} {{ item.user?.lastName }}</p>
        <p>{{ item.user?.email }}</p>
      </span>
      <sn-icon-button
        (click)="download()"
        [matTooltip]="'common.download' | t"
        matTooltipPosition="below"
        color="success"
        icon="get_app"
      >
      </sn-icon-button>
    </div>
  </ng-template>
  <ng-template #icon>
    <div>
      <span class="title">
        <p>{{ item?.description ? item?.description : title }}</p>
        <p>{{ item.user?.firstName }} {{ item.user?.lastName }}</p>
        <p class="email">{{ item.user?.email }}</p>
      </span>
      <sn-icon class="file-icon" fontSet="fa" fontIcon="fa-file"></sn-icon>
      <sn-icon-button
        (click)="download()"
        [matTooltip]="'common.download' | t"
        matTooltipPosition="below"
        color="success"
        icon="get_app"
      >
      </sn-icon-button>
    </div>
  </ng-template>
</div>
